<template>
  <button class="icon-btn" :aria-label="props.type" @click="clicked">
    <svg v-if="props.type == 'settings'" viewBox="0 0 20 20" fill="none">
      <path d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z" stroke="currentColor" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M16.1666 12.5C16.0557 12.7513 16.0226 13.0302 16.0716 13.3005C16.1207 13.5708 16.2495 13.8203 16.4416 14.0167L16.4916 14.0667C16.6466 14.2215 16.7695 14.4053 16.8534 14.6076C16.9373 14.8099 16.9805 15.0268 16.9805 15.2458C16.9805 15.4649 16.9373 15.6817 16.8534 15.8841C16.7695 16.0864 16.6466 16.2702 16.4916 16.425C16.3368 16.58 16.153 16.7029 15.9507 16.7868C15.7484 16.8707 15.5315 16.9139 15.3125 16.9139C15.0934 16.9139 14.8766 16.8707 14.6743 16.7868C14.4719 16.7029 14.2881 16.58 14.1333 16.425L14.0833 16.375C13.8869 16.1829 13.6374 16.0541 13.3671 16.005C13.0967 15.956 12.8179 15.9891 12.5666 16.1C12.3202 16.2056 12.1124 16.381 11.9673 16.6046C11.8221 16.8282 11.7461 17.0902 11.75 17.3583V17.5C11.75 17.942 11.5744 18.366 11.2618 18.6785C10.9493 18.9911 10.5253 19.1667 10.0833 19.1667C9.6413 19.1667 9.21738 18.9911 8.90482 18.6785C8.59226 18.366 8.41667 17.942 8.41667 17.5V17.425C8.41369 17.1492 8.32762 16.8817 8.16986 16.6573C8.01209 16.4328 7.78997 16.2619 7.53333 16.1667C7.28197 16.0557 7.00316 16.0226 6.73284 16.0717C6.46251 16.1207 6.21303 16.2495 6.01667 16.4417L5.96667 16.4917C5.81186 16.6466 5.62806 16.7696 5.42574 16.8535C5.22342 16.9374 5.00657 16.9805 4.7875 16.9805C4.56843 16.9805 4.35157 16.9374 4.14926 16.8535C3.94694 16.7696 3.76314 16.6466 3.60833 16.4917C3.45338 16.3369 3.33044 16.1531 3.24654 15.9507C3.16263 15.7484 3.11949 15.5316 3.11949 15.3125C3.11949 15.0934 3.16263 14.8766 3.24654 14.6743C3.33044 14.4719 3.45338 14.2881 3.60833 14.1333L3.65833 14.0833C3.85044 13.887 3.97925 13.6375 4.0283 13.3672C4.07735 13.0968 4.04421 12.818 3.93333 12.5667C3.82774 12.3202 3.65236 12.1124 3.42875 11.9673C3.20515 11.8221 2.94314 11.7461 2.675 11.75H2.5C2.05797 11.75 1.63405 11.5744 1.32149 11.2618C1.00893 10.9493 0.833333 10.5254 0.833333 10.0833C0.833333 9.6413 1.00893 9.21738 1.32149 8.90482C1.63405 8.59226 2.05797 8.41667 2.5 8.41667H2.575C2.85083 8.41369 3.11828 8.32762 3.34274 8.16986C3.5672 8.01209 3.73812 7.78997 3.83333 7.53333C3.94421 7.28197 3.97735 7.00316 3.9283 6.73284C3.87925 6.46251 3.75044 6.21303 3.55833 6.01667L3.50833 5.96667C3.35338 5.81186 3.23044 5.62806 3.14654 5.42574C3.06263 5.22342 3.01949 5.00657 3.01949 4.7875C3.01949 4.56843 3.06263 4.35157 3.14654 4.14926C3.23044 3.94694 3.35338 3.76314 3.50833 3.60833C3.66314 3.45338 3.84694 3.33044 4.04926 3.24654C4.25157 3.16263 4.46843 3.11949 4.6875 3.11949C4.90657 3.11949 5.12342 3.16263 5.32574 3.24654C5.52806 3.33044 5.71186 3.45338 5.86667 3.60833L5.91667 3.65833C6.11303 3.85044 6.36251 3.97925 6.63284 4.0283C6.90316 4.07735 7.18197 4.04421 7.43333 3.93333H7.5C7.74641 3.82774 7.95423 3.65236 8.09936 3.42875C8.24448 3.20515 8.32055 2.94314 8.31667 2.675V2.5C8.31667 2.05797 8.49226 1.63405 8.80482 1.32149C9.11738 1.00893 9.5413 0.833333 9.98333 0.833333C10.4254 0.833333 10.8493 1.00893 11.1618 1.32149C11.4744 1.63405 11.65 2.05797 11.65 2.5V2.575C11.6461 2.84314 11.7222 3.10515 11.8673 3.32875C12.0124 3.55236 12.2202 3.72774 12.4667 3.83333C12.718 3.94421 12.9968 3.97735 13.2672 3.9283C13.5375 3.87925 13.787 3.75044 13.9833 3.55833L14.0333 3.50833C14.1881 3.35338 14.3719 3.23044 14.5743 3.14654C14.7766 3.06263 14.9934 3.01949 15.2125 3.01949C15.4316 3.01949 15.6484 3.06263 15.8507 3.14654C16.0531 3.23044 16.2369 3.35338 16.3917 3.50833C16.5466 3.66314 16.6696 3.84694 16.7535 4.04926C16.8374 4.25157 16.8805 4.46843 16.8805 4.6875C16.8805 4.90657 16.8374 5.12342 16.7535 5.32574C16.6696 5.52806 16.5466 5.71186 16.3917 5.86667L16.3417 5.91667C16.1496 6.11303 16.0208 6.36251 15.9717 6.63284C15.9227 6.90316 15.9558 7.18197 16.0667 7.43333V7.5C16.1723 7.74641 16.3476 7.95423 16.5712 8.09936C16.7948 8.24448 17.0569 8.32055 17.325 8.31667H17.5C17.942 8.31667 18.366 8.49226 18.6785 8.80482C18.9911 9.11738 19.1667 9.5413 19.1667 9.98333C19.1667 10.4254 18.9911 10.8493 18.6785 11.1618C18.366 11.4744 17.942 11.65 17.5 11.65H17.425C17.1569 11.6461 16.8948 11.7222 16.6712 11.8673C16.4476 12.0124 16.2723 12.2202 16.1666 12.4667V12.5Z" stroke="currentColor" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <svg v-if="props.type == 'delete'" viewBox="0 0 20 20" fill="none">
      <path d="M2.5 5H4.16667H17.5" stroke="currentColor" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M6.66666 5V3.33333C6.66666 2.89131 6.84225 2.46738 7.15481 2.15482C7.46737 1.84226 7.8913 1.66667 8.33332 1.66667H11.6667C12.1087 1.66667 12.5326 1.84226 12.8452 2.15482C13.1577 2.46738 13.3333 2.89131 13.3333 3.33333V5M15.8333 5V16.6667C15.8333 17.1087 15.6577 17.5326 15.3452 17.8452C15.0326 18.1577 14.6087 18.3333 14.1667 18.3333H5.83332C5.3913 18.3333 4.96737 18.1577 4.65481 17.8452C4.34225 17.5326 4.16666 17.1087 4.16666 16.6667V5H15.8333Z" stroke="currentColor" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <svg v-if="props.type == 'github'" viewBox="0 0 20 20" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10 0C4.475 0 0 4.475 0 10C0 14.425 2.8625 18.1625 6.8375 19.4875C7.3375 19.575 7.525 19.275 7.525 19.0125C7.525 18.775 7.5125 17.9875 7.5125 17.15C5 17.6125 4.35 16.5375 4.15 15.975C4.0375 15.6875 3.55 14.8 3.125 14.5625C2.775 14.375 2.275 13.9125 3.1125 13.9C3.9 13.8875 4.4625 14.625 4.65 14.925C5.55 16.4375 6.9875 16.0125 7.5625 15.75C7.65 15.1 7.9125 14.6625 8.2 14.4125C5.975 14.1625 3.65 13.3 3.65 9.475C3.65 8.3875 4.0375 7.4875 4.675 6.7875C4.575 6.5375 4.225 5.5125 4.775 4.1375C4.775 4.1375 5.6125 3.875 7.525 5.1625C8.325 4.9375 9.175 4.825 10.025 4.825C10.875 4.825 11.725 4.9375 12.525 5.1625C14.4375 3.8625 15.275 4.1375 15.275 4.1375C15.825 5.5125 15.475 6.5375 15.375 6.7875C16.0125 7.4875 16.4 8.375 16.4 9.475C16.4 13.3125 14.0625 14.1625 11.8375 14.4125C12.2 14.725 12.5125 15.325 12.5125 16.2625C12.5125 17.6 12.5 18.675 12.5 19.0125C12.5 19.275 12.6875 19.5875 13.1875 19.4875C15.1727 18.8173 16.8977 17.5415 18.1197 15.8395C19.3417 14.1376 19.9994 12.0953 20 10C20 4.475 15.525 0 10 0Z" fill="currentColor"/>
    </svg>
    <svg v-if="props.type == 'pwa'" viewBox="0 0 20 20" fill="none">
      <path d="M6.66667 13.3333V11.6667H3.33333C2.89131 11.6667 2.46738 11.4911 2.15482 11.1785C1.84226 10.866 1.66667 10.442 1.66667 10V4.16667C1.66667 3.72464 1.84226 3.30072 2.15482 2.98816C2.46738 2.6756 2.89131 2.5 3.33333 2.5H10V4.16667H3.33333V10H10V8.33333H11.6667V10H16.6667V6.66667H18.3333V10C18.3333 10.442 18.1577 10.866 17.8452 11.1785C17.5326 11.4911 17.1087 11.6667 16.6667 11.6667H13.3333V13.3333H6.66667Z" fill="currentColor"/>
      <path d="M14.1667 8.33333L12.9917 7.15833L14.3167 5.83333H11.6667V4.16667H14.3167L12.9917 2.84167L14.1667 1.66667L17.5 5L14.1667 8.33333Z" fill="currentColor"/>
    </svg>
    <span v-if="popoverText" class="tooltip">{{ props.popoverText }}</span>
  </button>
</template>

<script setup lang="ts">
const props = defineProps({
  type: {
    type: String,
    default: 'delete'
  },
  popoverText: {
    type: String,
    default: ''
  },
})

const emit = defineEmits(['clicked']);

const clicked = () => {
  emit('clicked');
}
</script>

<style scoped lang="scss">
.icon-btn {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  border: 1px solid var(--gray-300, #D0D5DD);
  border-radius: var(--radius-md, 8px);
  background: #fff;
  color: var(--gray-700, #344054);
  cursor: pointer;
  transition: all 0.15s ease;

  svg {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
  }

  &:hover {
    background: var(--gray-50, #F9FAFB);
    border-color: var(--gray-300, #D0D5DD);
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0px 0px 0px 4px var(--gray-100, #F2F4F7), 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  }

  &:active {
    background: var(--gray-100, #F2F4F7);
  }
}

.tooltip {
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  padding: 8px 12px;
  background: var(--gray-900, #101828);
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
  white-space: nowrap;
  border-radius: var(--radius-md, 8px);
  box-shadow: var(--shadow-lg, 0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03));
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.15s ease, visibility 0.15s ease;
  pointer-events: none;

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 6px solid transparent;
    border-top-color: var(--gray-900, #101828);
  }
}

.icon-btn:hover .tooltip {
  opacity: 1;
  visibility: visible;
}
</style>
